App.controller('SurveySearchController', SurveySearchController);

SurveySearchController.$inject = [
    'surveys'
];

function SurveySearchController(surveys) {
    this.surveys = surveys;
}